<template>
  <div class="watchdetail-child2">
    <div class="watchdetail-child2-header">
      <div class="step">
        <span v-if="sleepTotal == ''">总共睡眠时间:暂无数据</span>
        <span v-else>总共睡眠时间:{{sleepTotal}}</span>
      </div>
      <div class="shuju">
        <span v-if="sleepStart==''">开始时间:暂无数据</span>
        <span class="shujukm" v-else>开始时间:{{sleepStart}}</span>
        <span v-if="sleepEnd==''">结束时间:暂无数据</span>
        <span class="shujukm" v-else>结束时间:{{sleepEnd}}</span>
        <span v-if="sleepLight==''">浅睡时间:暂无数据</span>
        <span class="shujukm" v-else>浅睡时间:{{sleepLight}}</span>
        <span v-if="sleepDeep==''">深睡时间:暂无数据</span>
        <span class="shujukcal" v-else>深睡时间:{{sleepDeep}}</span>
      </div>
    </div>
    <div class="watchdetail-child2-main" style="position: relative;">
      <div class="watchdetail-child2-main-a">
        <el-tabs v-model="activeName2" class="echart" type="border-card" @tab-click="handleClick">
          <el-tab-pane label="日" name="first">
            <div id="myChartDay" ref="myChartDay" style="width:860px; height:400px;">
              <!-- 存放echart的实例数据-->
            </div>
          </el-tab-pane>
        </el-tabs>
        <div style="position:absolute;top:0;right:10px;width:230px;z-index:999;">
          <el-date-picker
            v-model="dataPick"
            type="date"
            @change="changeData"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
import util from '@/utils/util.js'
export default {
  data() {
    return {
      canvasSleep: "", //echart图数据状态
      activeName2: "first",
      sleepTotal: "", //总共睡眠时间
      sleepDeep: "", //深睡时间
      sleepLight: "", //浅睡时间
      sleepStart: "", //睡眠开始时间
      sleepEnd: "", //睡眠结束时间
      sleepTime: [], //睡觉时间的开始到结束时间 x轴
      sleeY: [], //图 Y轴
      deviceId: this.$route.query.id, //设备id
      dataPick: util.formatDate.format(new Date(), "yyyy-MM-dd"), //选取的时间的值
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    //选取的时间
    changeData(value) {
      console.log(value);
      this.dataPick = value;
      this.drawChart();
    },
    //获取心率数据图
    drawDay() {
      // 基于准备好的dom，初始化echarts实例
      var chartDay = this.$refs.myChartDay;
      if (chartDay) {
        let myChartDay = echarts.init(chartDay);
        myChartDay.showLoading(); //加载动画
        //传参 axios发起数据请求
        let parma = {
          deviceId: this.deviceId * 1,
          date: this.dataPick
        };
        console.log(parma);
        this.sleepTime = [];
        this.sleeY = [];
        this.$postJson("dmc/watch/queryHistSleepWithDay", parma).then(res => {
          console.log(res);
          this.canvasSleep = res.result;
          //不为null就取值 ，否则就将结果置空
          if (res.result !== null) {
            this.sleepTotal = res.result.sleepTotal;
            this.sleepTotal =
              this.sleepTotal.substring(0, 2) +
              "时" +
              this.sleepTotal.substring(2, this.sleepTotal.length) +
              "分";
            this.sleepDeep = res.result.sleepDeep;
            this.sleepDeep =
              this.sleepDeep.substring(0, 2) +
              "时" +
              this.sleepDeep.substring(2, this.sleepDeep.length) +
              "分";
            this.sleepLight = res.result.sleepLight;
            this.sleepLight =
              this.sleepLight.substring(0, 2) +
              "时" +
              this.sleepLight.substring(2, this.sleepLight.length) +
              "分";
            this.sleepStart = res.result.sleepStart;
            // this.sleepStart=this.sleepStart.substring(0,4)+'-'+this.sleepStart.substring(4,6)+'-'+this.sleepStart.substring(6,8)+' '+this.sleepStart.substring(8,10)+':'+this.sleepStart.substring(10,12)+':'+this.sleepStart.substring(12,this.sleepStart.length);//处理时间格式
            this.sleepEnd = res.result.sleepEnd;
            //this.sleepEnd=this.sleepEnd.substring(0,4)+'-'+this.sleepEnd.substring(4,6)+'-'+this.sleepEnd.substring(6,8)+' '+this.sleepEnd.substring(8,10)+':'+this.sleepEnd.substring(10,12)+':'+this.sleepEnd.substring(12,this.sleepEnd.length);//处理时间格式
            // this.sleepTime.splice(
            //   0,
            //   2,
            //   res.result.sleepStart,
            //   res.result.sleepEnd
            // );
            var sleepDeepMin=res.result.sleepDeep.substring(0, 2)*60+res.result.sleepDeep.substring(2, res.result.sleepDeep.length)*1;
            var sleepLightMin=res.result.sleepLight.substring(0, 2)*60+res.result.sleepLight.substring(2, res.result.sleepLight.length)*1;
            console.log(sleepDeepMin,sleepLightMin,"sleepLightMin")
            this.sleepTime.push({value:sleepDeepMin,name:'深睡'},{value:sleepLightMin,name:"浅睡"})
            this.sleeY.splice(
              0,
              2,
              res.result.sleepLight,
              res.result.sleepDeep
            );
          } else {
            this.sleepTotal = "";
            this.sleepDeep = "";
            this.sleepLight = "";
            this.sleepStart = "";
            this.sleepEnd = "";
          }
          setTimeout(() => {
            myChartDay.hideLoading(); //加载成功关闭动画
          }, 500);
          //将后台获取的值注入data中，echaert图形展示获取的数据
          // 绘制图表
        //   myChartDay.setOption({
        //     title: {
        //       text: "睡眠时间图"
        //     },
        //     tooltip: {
        //       trigger: "axis"
        //     },
        //     legend: {
        //       data: ["心率值"]
        //     },
        //     grid: {
        //       left: "3%",
        //       right: "4%",
        //       bottom: "3%",
        //       containLabel: true
        //     },
        //     toolbox: {
        //       //x:'610',//下载的字体显示不全
        //       x: "90%", //下载的字体显示不全
        //       feature: {
        //         saveAsImage: {}
        //       }
        //     },
        //     xAxis: {
        //       type: "category",
        //       boundaryGap: false,
        //       data: this.sleepTime
        //     },
        //     yAxis: {
        //       type: "value"
        //     },
        //     series: [
        //       {
        //         name: "睡眠时间",
        //         type: "line",
        //         data: this.sleeY
        //       }
        //     ]
        //   });
          myChartDay.setOption({
            title: {
              text: "睡眠",
              subtext: "时长占比",
              x: "center"
            },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            legend: {
              orient: "vertical",
              left: "left",
              data: [
                "深睡",
                "浅睡",
              ]
            },
            series: [
              {
                name: "时长占比",
                type: "pie",
                radius: ["50%", "70%"],
                avoidLabelOverlap: false,
                label: {
                  normal: {
                    show: false,
                    position: "center"
                  },
                  emphasis: {
                    show: true,
                    textStyle: {
                      fontSize: "30",
                      fontWeight: "bold"
                    }
                  }
                },
                labelLine: {
                  normal: {
                    show: false
                  }
                },
                data: this.sleepTime
              }
            ]
          });
        });
      }
    },
    drawChart() {
      this.drawDay();
    }
  },
  created() {
    this.drawChart(); //组件传创建时调用
  },
  mounted() {
    this.drawChart(); //组件加载时调用
  }
};
</script>
<style lang="scss" scoped>
.watchdetail-child2 {
  width: 98%;
  height: 98%;
  margin: 1%;
  .watchdetail-child2-header {
    height: 20%;
    padding: 5px;
    border: 1px solid rgb(243, 234, 234);
    display: flex;
    flex-direction: column;
    align-items: center;
    .step {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50%;
      font-size: 16px;
      color: rgb(100, 92, 92);
    }
    .shuju {
      height: 50%;
      width: 100%;
      display: flex;
      font-size: 16px;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      color: rgb(100, 92, 92);
      .shujukm {
        text-align: center;
        width: 25%;
      }
      .shujukcal {
        width: 25%;
        text-align: center;
      }
    }
  }
  .watchdetail-child2-main {
    height: 76%;
    margin-top: 10px;
    border: 1px solid rgb(243, 234, 234);
  }
}
::v-deep .el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
}

@media screen and (min-width: 1000px) and (max-width: 1530px) {
  ::v-deep #myChartDay {
    //width:660px !important;
    width: 99% !important;
  }
}
@media screen and (min-width: 1531px) and (max-width: 1920px) {
  ::v-deep #myChartDay {
    //width:850px !important;
    width: 99% !important;
  }
}

@media screen and (min-width: 1921px) {
  ::v-deep #myChartDay {
    // width:850px !important;
    width: 99% !important;
  }
}
</style>
